import React from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import Typography from "../../typography/typography";
import AddPageModal from "./add-page-modal";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { IPage } from "../../../@types/page";
import SharedPageModal from "./shared-page-modal";

interface IAddPage {
  sharedPages: any;
  handleAddPage: (view: IPage) => void;
  pages?: IPage[];
}

const AddPage = ({ sharedPages, handleAddPage, pages }: IAddPage) => {
  const [isAddMenuOpen, setIsAddMenuOpen] = React.useState<null | HTMLElement>(
    null,
  );
  const [isAddPageModalOpen, setIsAddPageModalOpen] = React.useState(false);
  const [isSharedPageModalOpen, setIsSharedPageModalOpen] =
    React.useState(false);

  const handleAddMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setIsAddMenuOpen(event.currentTarget);
  };
  const handleAddMenuClose = () => setIsAddMenuOpen(null);

  const handleOpenAddPageModal = () => {
    handleAddMenuClose();
    setIsAddPageModalOpen(true);
  };
  const handleCloseAddPageModal = () => setIsAddPageModalOpen(false);

  const handleCloseSharedModal = () => {
    setIsSharedPageModalOpen(false);
  };
  const handleOpenSharedPageModal = () => {
    setIsSharedPageModalOpen(true);
    setIsAddMenuOpen(null);
  };
  const handleShared = (page: any) => {
    const newPage: any = { ...page.details, name: page.name };
    handleAddPage(newPage);
    setIsSharedPageModalOpen(false);
  };

  return (
    <>
      <IconButton size="small" sx={{ ml: 1 }} onClick={handleAddMenuOpen}>
        <AddCircleOutlineRoundedIcon fontSize="inherit" />
      </IconButton>
      <Menu
        open={Boolean(isAddMenuOpen)}
        anchorEl={isAddMenuOpen}
        onClose={handleAddMenuClose}
      >
        <MenuItem onClick={handleOpenAddPageModal}>
          <Typography color="theme.secondary.1000" type="s4">
            Create New View
          </Typography>
        </MenuItem>
        <MenuItem onClick={handleOpenSharedPageModal}>
          <Typography color="theme.secondary.1000" type="s4">
            Shared Views
          </Typography>
          <KeyboardArrowRightIcon fontSize="small" />
        </MenuItem>
      </Menu>

      <AddPageModal
        pages={pages}
        open={isAddPageModalOpen}
        onClose={handleCloseAddPageModal}
        handleSubmit={handleAddPage}
      />
      <SharedPageModal
        open={isSharedPageModalOpen}
        pages={sharedPages || []}
        onClose={handleCloseSharedModal}
        handleSubmit={handleShared}
      />
    </>
  );
};

export { AddPage };
export default AddPage;
